<template>
    <div ref="toolbarChat">
        <div :class="'popup'+visible">
            <div :class="'popup__content popup__content--'+size">
                <div :class="header">
                    <div v-if="classTitle" :class="classTitle">{{title}}</div>
                     <div v-else class="popup__title">{{title}}</div>
                </div>
                <span class="popup__close" @click="toggleModal"><img :src="header=='popup__header-admin'||header=='popup__header-edit'?'/img/icons/InoCerrarPDF.svg':'/img/icons/InoCerrar.svg'" alt="cerrar"></span>
                <slot></slot>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapMutations} from "vuex";
    export default {
        props: ["size", "title", "header" , "classTitle", "eventHub"],
        name: "PopupApp",
        data(){
            return {
                open: false
            }
        },
        computed: {
            visible(){
                return this.open ? ' popup--visible' : '';
            }
        },
        methods: {
            ...mapMutations(["cleanApp"]),
            toggleModal(){
                if(this.open){
                    //this.cleanApp("")
                this.eventHub.$emit('closeall')
                }
                
                this.$nextTick(() => {
                    this.$refs.toolbarChat.scrollTop = 0;
                });
                this.open = !this.open;
            }
        }
    }
</script>